// Payroll Run Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE.
//
// The backend registers these through PermissionService::createAndGrantToOwners
// in database/migrations/2026_09_05_000004_add_payroll_run_permissions.php, and
// the central key service allocates each row's id at migrate time — none of them
// can be known while writing this file. 1523-1530 are counted forward from the
// confirmed 1522 (HR_MANAGE_SETTINGS) in registration order — derived, not read.
//
// Read the real ids off the live rows once the migration has run and correct
// these constants:
//
//     SELECT id, name FROM permissions WHERE name LIKE 'payroll_runs.%';
//
// The failure mode is deliberately closed: a wrong number means nobody holds it
// and the control is hidden, never shown to the wrong people. Never pick an id
// another permissions file already declares.
export const PAYROLL_RUNS_INDEX = 1523;
export const PAYROLL_RUNS_CREATE = 1524;
export const PAYROLL_RUNS_UPDATE = 1525;
export const PAYROLL_RUNS_DELETE = 1526;
export const PAYROLL_RUNS_RESTORE = 1527;
export const PAYROLL_RUNS_SUBMIT = 1528;
export const PAYROLL_RUNS_APPROVE = 1529;
export const PAYROLL_RUNS_PAY = 1530;
